// These values are the Electron built-in values as of v4.
export const zoomLevelIncrement = 0.5;
export const zoomLevelMin = -8;
export const zoomLevelMax = 9;

export enum ZoomOperation {
  ZOOM_IN,
  ZOOM_OUT,
}
